import { Component, OnInit, inject } from '@angular/core';
import { DialogBaseComponent } from 'shared/dialogs/dialog-base/dialog-base.component';
import {
  SelectCardComponent,
  SelectCardOption
} from 'shared/components/select-card/select-card.component';
import { DeviceService } from 'services/device.service';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { Profile } from 'models/profile';
import { QueryParam } from 'services/utility.service';
import { ProfileService } from 'services/profile.service';
import { MatFormField, MatOption, MatSelect } from '@angular/material/select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';

enum AddNewType {
  Device = 'DEVICE',
  // eslint-disable-next-line @typescript-eslint/no-shadow
  Profile = 'PROFILE',
  Exception = 'EXCEPTION'
}

@Component({
  selector: 'core-ui-add-new-dialog',
  imports: [
    DialogBaseComponent,
    SelectCardComponent,
    MatSelect,
    MatOption,
    MatFormField,
    TranslateModule,
    AsyncPipe
  ],
  templateUrl: './add-new-dialog.component.html',
  styleUrl: './add-new-dialog.component.scss'
})
export class AddNewDialogComponent implements OnInit {
  public options: SelectCardOption<AddNewType>[];
  public profiles$: Observable<Profile[]>;
  public profile: Profile;
  public value: AddNewType;
  private deviceService = inject(DeviceService);
  private router = inject(Router);
  private dialogRef = inject<MatDialogRef<AddNewDialogComponent>>(MatDialogRef);
  private profileService = inject(ProfileService);
  private translateService = inject(TranslateService);

  public ngOnInit(): void {
    this.deviceService
      .getLicenses$()
      .pipe(
        tap((licenses) => {
          this.initOptions(licenses.totalAvailable);
        })
      )
      .subscribe();

    this.profiles$ = this.profileService.getProfiles$();
  }

  private initOptions(deviceLicenses: number): void {
    this.options = [
      {
        label: this.translateService.instant('NAVBAR.ADD_NEW_DIALOG.DEVICE'),
        icon: 'devices',
        value: AddNewType.Device,
        disabled: !deviceLicenses
      },
      {
        label: this.translateService.instant('NAVBAR.ADD_NEW_DIALOG.PROFILE'),
        icon: 'account_circle',
        value: AddNewType.Profile
      },
      {
        label: this.translateService.instant('NAVBAR.ADD_NEW_DIALOG.EXCEPTION'),
        icon: 'rule',
        value: AddNewType.Exception
      }
    ];
  }

  public create(): void {
    switch (this.value) {
      case AddNewType.Device:
        this.navigateTo('devices');
        break;
      case AddNewType.Profile:
        this.navigateTo('profiles');
        break;
      case AddNewType.Exception:
        this.navigateTo(`profiles/${this.profile.id}/exceptions`);
        break;
    }

    this.dialogRef.close();
  }

  private navigateTo(route: string): void {
    this.router.navigate(['']).then(() => {
      this.router.navigate([route], {
        queryParams: {
          [QueryParam.ADD_NEW]: true
        }
      });
    });
  }

  public get AddNewType(): typeof AddNewType {
    return AddNewType;
  }
}
